import React from "react";
import { Helmet } from "react-helmet";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import CheckCircle from "@material-ui/icons/CheckCircle";
import MailOutline from "@material-ui/icons/MailOutline";
import AccessTime from "@material-ui/icons/AccessTime";

import Button from "components/Button";
import { container, main } from "assets/jss/material-kit-pro-react.jsx";
import buttonStyle from "assets/jss/material-kit-pro-react/components/buttonStyle.jsx";
import { rootUrl } from "../../config";

const styles = theme => ({
  ...buttonStyle,
  container: {
    ...container,
  },
  main,
  wrapper: {
    minHeight: "calc(100vh - 260px)",

    background: "linear-gradient(180deg, #f7fbff 0%, #ffffff 100%)",

    display: "flex",

    alignItems: "flex-start", // was center

    justifyContent: "center",

    padding: "80px 20px 100px", // increase top padding
  },
  card: {
    background: "#ffffff",
    maxWidth: 650,
    width: "100%",
    borderRadius: 18,
    padding: "42px 40px",
    marginTop: "20px",
    boxShadow: "0 20px 60px rgba(34,43,52,.10)",
    border: "1px solid #eef3f7",
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    background: "linear-gradient(135deg,#1d9cd9,#42bcee)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
    boxShadow: "0 12px 25px rgba(29,156,217,.25)",
  },

  checkIcon: {
    color: "#fff",
    fontSize: 42,
  },
  title: {
    color: "#222b34",
    fontSize: "3rem",
    fontWeight: 600,
    marginBottom: 18,
    textAlign: "center", // Add this
  },
  message: {
    fontSize: 18,
    color: "#5f6670",
    maxWidth: 620,
    margin: "0 auto 34px",
    lineHeight: 1.8,
    textAlign: "center", // Add this
  },
  infoRow: {
    display: "flex",
    justifyContent: "center",
    gap: 18,
    marginBottom: 36,
    flexWrap: "wrap",
  },
  infoBox: {
    width: 220,
    padding: "18px 16px",
    borderRadius: 14,
    backgroundColor: "#f7f9fa",
    border: "1px solid #edf1f4",
  },
  infoIcon: {
    color: "#1d9cd9",
    fontSize: 28,
    marginBottom: 8,
  },
  infoText: {
    fontSize: 15,
    color: "#555",
    margin: 0,
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    gap: 14,
    flexWrap: "wrap",
  },
  primaryButton: {
    backgroundColor: "#1d9cd9",
    "&:hover,&:focus": {
      backgroundColor: "#42bcee",
    },
  },
  secondaryButton: {
    color: "#1d9cd9",
    border: "1px solid #1d9cd9",
    backgroundColor: "#ffffff",
    "&:hover,&:focus": {
      backgroundColor: "#f2fbff",
    },
  },
});

const ContactThankYou = ({ classes }) => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Thank You | Jaza Software</title>
      <link rel="canonical" href={`${rootUrl}/contact/thank-you`} />
    </Helmet>

    <div className={classes.main}>
      <section className={classes.wrapper}>
        <div className={classes.card}>
          <div className={classes.iconCircle}>
            <CheckCircle className={classes.checkIcon} />
          </div>

          <Typography variant="h3" className={classes.title}>
            Thank You!
          </Typography>

          <Typography className={classes.message}>
            Your message has been submitted successfully. Our team has received your request and will get back to you
            shortly.
          </Typography>

          <div className={classes.infoRow}>
            <div className={classes.infoBox}>
              <MailOutline className={classes.infoIcon} />
              <p className={classes.infoText}>We have received your enquiry.</p>
            </div>

            <div className={classes.infoBox}>
              <AccessTime className={classes.infoIcon} />
              <p className={classes.infoText}>Our team will contact you soon.</p>
            </div>
          </div>

          <div className={classes.actions}>
            <Button color="primary" className={classes.primaryButton} onClick={() => (window.location.href = "/")}>
              Back to Home
            </Button>

            <Button className={classes.secondaryButton} onClick={() => (window.location.href = "/contact")}>
              Submit Another Request
            </Button>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default withStyles(styles)(ContactThankYou);
